import axios from 'axios';
import store from '@/store';

const apiClient = axios.create({
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor: resolve baseURL and attach auth token
apiClient.interceptors.request.use((config) => {
    config.baseURL = store.state.baseURL[store.state.env];

    const token = store.state.user.accessToken;
    if (token) {
        config.headers['X-Access-Token'] = token;
    }

    return config;
});

// Response interceptor: handle 401 by clearing token
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('access_token');
            store.commit('destroyAccessToken');
            store.commit('resumeSync');
            store.commit('cancelSyncTimer');
        }
        return Promise.reject(error);
    }
);

export function apiGet(endpoint, params = null, config = {}) {
    return apiClient.get(endpoint, { params, ...config });
}

export function apiPost(endpoint, data = null, config = {}) {
    return apiClient.post(endpoint, data, config);
}

export function apiPut(endpoint, data = null, config = {}) {
    return apiClient.put(endpoint, data, config);
}

export function apiPatch(endpoint, data = null, config = {}) {
    return apiClient.patch(endpoint, data, config);
}

export function apiDelete(endpoint, config = {}) {
    return apiClient.delete(endpoint, config);
}

export default apiClient;
